"use client"

import React from 'react';
import { Database, Code, Share2, Sparkles, Filter, GitBranch, RotateCw, Clock, Send, History,   X,
  ActivityIcon as Function,
  ArrowLeft,
  CheckSquare } from 'lucide-react';
import "./ConnectionBlocksMenu.css"

const ConnectionBlocksMenu = ({ position, onClose, onSelectBlock }) => {
  const menuItems = [
    { id: "resource-query", label: "Resource query", icon: <Database size={20} />, color: "#818cf8" },
    { id: "task", label: "Task", icon: <CheckSquare size={20} />, color: "#10b981" },
    { id: "workflow", label: "Workflow", icon: <Share2 size={20} />, color: "#818cf8" },
    { id: "filter", label: "Filter", icon: <Filter size={20} />, color: "#94a3b8" },
    { id: "branch", label: "If/Else", icon: <GitBranch size={20} />, color: "#94a3b8" },
    { id: "run-function", label: "Run Function", icon: <Function size={20} />, color: "#94a3b8" },
    { id: "wait", label: "Wait", icon: <Clock size={20} />, color: "#94a3b8" },
    { id: "response", label: "Response", icon: <ArrowLeft size={20} />, color: "#10b981" },

  ];
  console.log("showing connection blocks menu")
  return (
    <div
      className="connection-blocks-menu"
      style={{
        position: 'fixed',
        left: position.x,
        top: position.y,
        zIndex: 1000,
      }}
    >
      <div className="menu-header">Add block</div>
      <div className="menu-items">
        {menuItems.map((item) => (
          <button
            key={item.id}
            className="menu-item"
            onClick={() => {
              onSelectBlock(item.id);
              onClose();
            }}
          >
            <span className="menu-item-icon">{item.icon}</span>
            <span className="menu-item-label">{item.label}</span>
            {item.isNew && <span className="new-badge">New</span>}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ConnectionBlocksMenu
